import {css} from 'lit';
export const styles = css`.summary-table{width:100%}`;
export default styles;
